import { StudentProblemResult } from '@yandex-int/k-common/typings';
// @ts-ignore
import formatTime from '@yandex-int/k-common/utils/format-time';
import { Text } from 'platform-components';
import React from 'react';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const StudentTime = (props: { studentProblemResult: StudentProblemResult | null; isEvaluated: boolean }) => {
    const { studentProblemResult, isEvaluated } = props;
    const value = isEvaluated ? formatTime(studentProblemResult?.time) : null;

    return (
        <StatItem>
            <Text
                id="studentLessonStat.timeToComplete"
                values={{
                    mode: studentProblemResult?.type,
                }}
            />
            <span className="lesson-content__stat-detail-value qa_stat-detail-time">
                <Text weight={Text.WEIGHT.L}>{value || <>&mdash;</>}</Text>
            </span>
        </StatItem>
    );
};
